import React, { useMemo } from 'react';

import { useParams } from 'react-router';

import { Grid } from '@mui/material';
import { FormikHelpers, FormikProps } from 'formik';
import * as Yup from 'yup';

import { CissTextField } from 'components/fields';
import { Row } from 'components/form';
import { Block, FormPage } from 'components/page';
import { useFormContext } from 'context/FormContext';
import { useFormMutation } from 'mutations/useFormMutation';
import { initialOperacaoValues, RequestOperacaoProps } from 'pages/complementar/operacoes/types';

export function OperacoesFormComp() {
    const { setContent } = useFormContext();
    const url = '/gestao/operacao';
    const { id } = useParams();
    const { mutate } = useFormMutation();

    const handleSubmit = (values: RequestOperacaoProps, formik: FormikHelpers<RequestOperacaoProps>): void => {
        mutate(
            {
                url,
                idField: 'idOperacao',
                formData: values,
                formik,
            },
            {
                onSuccess: (response: any) => {
                    const { data } = response.data;

                    if (data) {
                        setContent(data);
                    }
                },
            },
        );
    };

    const validationSchema = useMemo(
        (): any =>
            Yup.object({
                dsOperacao: Yup.string().required(),
                cdOperacao: Yup.string().required(),
                fgAtivo: Yup.boolean().required(),
            }),
        [],
    );

    return (
        <FormPage
            title="Operação"
            values={initialOperacaoValues}
            fgAtivo={false}
            onSubmit={handleSubmit}
            url={url}
            validationSchema={validationSchema}
            goBackButton
        >
            {(formik: FormikProps<RequestOperacaoProps>) => {
                return (
                    <Block>
                        <Row>
                            {id && (
                                <Grid sx={{ flex: 1 }}>
                                    <CissTextField label="Código" value={id} disabled={true} />
                                </Grid>
                            )}

                            <Grid sx={{ flex: 1 }}>
                                <CissTextField
                                    label="Nome da Operação"
                                    value={formik.values.dsOperacao}
                                    name="dsOperacao"
                                    error={Boolean(formik.errors.dsOperacao)}
                                    helperText={formik.errors.dsOperacao && String(formik.errors.dsOperacao)}
                                    onChange={(e) => formik.setFieldValue('dsOperacao', e.target.value)}
                                />
                            </Grid>

                            <Grid sx={{ flex: 1 }}>
                                <CissTextField
                                    disabled={Boolean(id)}
                                    label="Código de Integração"
                                    name="cdOperacao"
                                    value={formik.values.cdOperacao}
                                    error={Boolean(formik.errors.cdOperacao)}
                                    helperText={formik.errors.cdOperacao && String(formik.errors.cdOperacao)}
                                    onChange={(e) => formik.setFieldValue('cdOperacao', e.target.value)}
                                />
                            </Grid>
                        </Row>
                    </Block>
                );
            }}
        </FormPage>
    );
}
